var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f7f45;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4427,649.018A11.031,11.031,0,0,1-4415.981,638a11.031,11.031,0,0,1,11.018,11.018,11.03,11.03,0,0,1-11.018,11.018A11.03,11.03,0,0,1-4427,649.018Zm1.786,0a9.243,9.243,0,0,0,9.233,9.232,9.242,9.242,0,0,0,9.231-9.232,9.242,9.242,0,0,0-9.231-9.232A9.243,9.243,0,0,0-4425.214,649.018Zm7.1,3.631-3.335-3.424a.894.894,0,0,1,.017-1.263.894.894,0,0,1,1.264.017l2.721,2.793,5.7-5.409a.892.892,0,0,1,1.263.033.892.892,0,0,1-.034,1.262l-6.343,6.016a.894.894,0,0,1-.615.244A.889.889,0,0,1-4418.111,652.649Z",
    transform: "translate(4427 -638)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.a28287b2f420d5559e5e3c42c2623a68.svg";
export { ForwardRef as ReactComponent };